import { useState } from "react";
import { Box, TextField, Button, Grid, Link } from "@mui/material";
import "./Login.css";
import "../../common/Common.css";
import { customButtonStyles } from "../../common/commonStyles";
import logo from "../../assets/logo.svg";
import ReusableSnackbar from "../../shared/Alert/ReusableSnackbar";
import api from "../../services/api";

const ForgotPassword = () => {
  const [formData, setFormData] = useState({
    email: "",
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const handleClose = () => setSnackbarOpen(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleForgotPassword = async () => {
    try {
      const { email } = formData;
      await api.post(
        `app/forgot-password`, // update with actual route prefix
        { email } // send JSON body
      );
      setSnackbarOpen(true);
      setFormData({ email: "" });
    } catch (error) {
      console.error(
        "Error sending reset email:",
        error.response?.data || error.message
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{ width: "100%", maxWidth: 400, mx: "auto" }}
          className="login-box"
        >
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <img src={logo} alt="Logo" style={{ height: 30, maxHeight: 30 }} />
          </Box>
          <Box>
            <h3 className="login-text">Hello!</h3>
            <h5 className="login_subtext">
              Enter your email and we will send you instructions to reset your
              password.
            </h5>
          </Box>
          <TextField
            required
            fullWidth
            label="Email address"
            name="email"
            id="fullWidth"
            margin="normal"
            value={formData.email}
            onChange={handleInputChange}
            autoComplete="off"
            className="custom-textfield"
          />
          <Button
            variant="contained"
            fullWidth
            sx={customButtonStyles}
            onClick={handleForgotPassword}
          >
            Continue
          </Button>
          <Grid container spacing={2}>
            <Grid size={12} className="create_account">
              Back to{" "}
              <Link href="/login" underline="none">
                Login
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <ReusableSnackbar
        open={snackbarOpen}
        message="Email Sent Successfully !"
        onClose={handleClose}
      />
    </>
  );
};

export default ForgotPassword;
